import type { EditAssetWorkflowOptions } from '../../types';

export const deleteCarrierScheduleWorkflow: EditAssetWorkflowOptions = {
  workflowKey: 'deleteCarrierScheduleWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'schedule',
  shipiumOnly: true,
  overrideSave: 'deleteCarrierSchedule',
  workflowActionIcon: 'DeleteOutlined',
  hideIfDisabled: true,
  assetSchemaMatcher: {
    type: 'object',
    properties: {
      entries: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            carrierSchedules: { type: 'array', minItems: 1 },
          },
        },
      },
    },
  },
  workflowIndex: 2,
  workflowName: 'Delete Carrier Schedule details',
  workflowDescription: `Remove carrier specific overrides from your fulfillment origin schedules.`,
  workflowStepOptions: [
    {
      workflowStepKey: 'scheduleEntryFrom',
      workflowStepNavigationName: 'Schedule Entry',
      workflowComponent: {
        workflowComponentType: 'scheduleEntrySelect',
        prompt: 'Which entries carrier schedule details do you need to update',
        allowMultiple: true,
        description: ``,
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'scheduleEntryFrom',
      },
      calculatedComponentProps: {
        scheduleId: {
          property: 'scheduleId',
          type: 'asset',
        },
      },
    },
    {
      workflowStepKey: 'carrier',
      workflowStepNavigationName: 'Carrier',
      workflowComponent: {
        workflowComponentType: 'carrierServiceMethodEntry',
        prompt: 'Which carrier does this schedule do you want to remove',
        hideCarriers: false,
        hideServiceMethods: true,
        singleSelect: true,
        description: ``,
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'carrier',
      },
      calculatedComponentProps: {
        allowedCarriers: {
          property: 'entries',
          type: 'asset',
          transformFn: (s) => {
            return s.reduce((accum: any, e: any) => {
              return [
                ...accum,
                ...e.carrierSchedules.reduce((carrierList: any, cs: any) => {
                  return [...carrierList, cs.carrierId];
                }, []),
              ];
            }, []);
          },
        },
      },
    },
    {
      workflowStepKey: 'allMethods',
      workflowStepNavigationName: 'Select Method?',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: 'Specify methods to remove?',
        description: ``,
        defaultValue: '',
        help: '',
        options: [
          {
            optionValue: true,
            optionText: 'No, apply to carrier',
          },
          {
            optionValue: false,
            optionText: 'Yes, specify methods to delete',
          },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
    {
      workflowStepKey: 'serviceMethods',
      workflowStepNavigationName: 'Service Methods',
      workflowComponent: {
        workflowComponentType: 'carrierServiceMethodEntry',
        prompt: 'Which service method does this schedule apply to?',
        hideCarriers: true,
        description: ``,
        defaultValue: '',
        help: '',
      },
      calculatedComponentProps: {
        allowedCarriers: {
          property: 'carrier',
          type: 'workflowStep',
          transformFn: (p) => [p],
        },
      },
      workflowStepConditionalMatcher: [{ workflowStepKey: 'allMethods', schema: { type: 'boolean', const: false } }],
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'serviceMethods',
      },
    },
    {
      workflowStepKey: 'deleteCarriersAndMethods',
      workflowStepNavigationName: 'Delete Carriers and Methods',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt:
          'Do you want to remove carrier schedule details for all methods of this carrier or only remove the carrier schedule details that apply at carrier level?',
        description: ``,
        defaultValue: '',
        help: 'Tell us if you want to wipe all service method schedule details for this carrier or only schedule detail that apply at the carrier level',
        options: [
          {
            optionValue: true,
            optionText: `I want to restore defaults for all of this carrier's schedules`,
          },
          {
            optionValue: false,
            optionText: `I want to keep service method level schedules in place`,
          },
        ],
      },
      workflowStepConditionalMatcher: [{ workflowStepKey: 'allMethods', schema: { type: 'boolean', const: true } }],
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'deleteCarriersAndMethods',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Delete Carrier Schedule Summary',
        description: 'Carrier schedule details will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
